import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminService } from '@app/services/admin/admin.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-admin-system-permissions-edit',
  templateUrl: './admin-system-permissions-edit.component.html'
})
export class AdminSystemPermissionsEditComponent implements OnInit, OnChanges {
  @Input() formdata;
  @Input() types;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  roles: SelectItem[] = [];

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService) { }

  ngOnInit() {
    this.form = this.fb.group({
      id: ['', ''],
      memberId: ['', ''],
      roleId: ['', ''],
      roleDescription: ['', ''],
      note: ['', ''],
      emailForSystemMessages: ['', '']
    });
    this.getRoles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
    }
  }

  saveSystemPermission() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }

  getRoles() {
    this.adminService.GetRoles().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.description, value: d.id
          };
          if (d.id === 12 || d.id === 13) {
            this.roles.push(record);
          }
        });
      }
    });
  }

  setRole(evt) {
    this.form.patchValue({ roleId: evt.value });
  }
}
